module.exports = __webpack_public_path__ + "assets/img/back2.f7a31560.png";